import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "../redux/store";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isRegistrationComplete, isPassedOptional } =
    useSelector((state: RootState) => state.user);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isRegistrationComplete && !isPassedOptional) {
    return <Navigate to="/select-account-type" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
